goog.provide("shadow.js.shim.module$src$svg$wpp$content$live_svg$default");
shadow.js.shim.module$src$svg$wpp$content$live_svg$default = shadow.js.shim.module$src$svg$wpp$content$live_svg.default;
